import { Header } from '@yanolja-org/core-ui';
import { IcClockFillH18, IcClockH18 } from '@yanolja-org/nol-icons-kit';

import type { HeaderActionProps, VisibleOn } from '@yanolja-org/core-ui';

/** preset 전용 — `'all'` 명시 시 양쪽 모두 노출. @see MyAction 의 PresetVisibleOn 주석 */
type PresetVisibleOn = VisibleOn | 'all';

export interface RecentViewActionProps extends Omit<HeaderActionProps, 'icon' | 'activeIcon' | 'action' | 'visibleOn'> {
  action?: string;
  /** 표시 디바이스. `'all'` = 양쪽 모두. @default 'desktop' */
  visibleOn?: PresetVisibleOn;
}

export function RecentViewAction({
  action = 'recent',
  label = '최근 본 상품',
  variant = 'label',
  visibleOn = 'desktop',
  href = '/recent-product/list?target=HOME',
  ...rest
}: RecentViewActionProps) {
  return (
    <Header.Action
      {...rest}
      action={action}
      activeIcon={<IcClockFillH18 />}
      href={href}
      icon={<IcClockH18 />}
      label={label}
      variant={variant}
      visibleOn={visibleOn === 'all' ? undefined : visibleOn}
    />
  );
}
